import type { JSONContent } from "@tiptap/react";

export interface CommentUser {
	mail: string;
	name: string;
}

export type CommentDateTime = string;

export interface CommentBlock<ContentType = JSONContent[]> {
	comment?: Comment<ContentType>;
	answers?: Comment<ContentType>[];
}

export interface Comment<ContentType = JSONContent[]> {
	dateTime: CommentDateTime;
	content: ContentType;
	/** absent in the file while there is no account behind the catalog; always set in memory */
	user?: CommentUser;
	assistedByAgent?: boolean;
}

/** The author of a comment left before there was an account; a value rather than `null` so every consumer can read `user.mail`. */
export const NO_AUTHOR: CommentUser = { mail: "", name: "" };

export const isUnsigned = (author: CommentUser) => !author?.mail;
